import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  inject,
  Injector,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { Title } from '@angular/platform-browser';
import { SessionMonitorService } from './core/auth/session-monitor.service';
import { APP_BRANDING } from './core/config/branding.config';
import {
  dismissBootShell,
  firstNavigationOutcome,
  type FirstNavigationOutcome,
  reportBootFailure,
} from './boot-failure';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App implements OnInit, OnDestroy {
  private readonly titleService = inject(Title);
  private readonly sessionMonitor = inject(SessionMonitorService);

  constructor() {
    const injector = inject(Injector);
    const settle: Record<FirstNavigationOutcome, () => void> = {
      rendered: () => afterNextRender(() => dismissBootShell(), { injector }),
      failed: () => reportBootFailure(),
    };
    inject(Router)
      .events.pipe(
        map(firstNavigationOutcome),
        filter((outcome): outcome is FirstNavigationOutcome => outcome !== null),
        take(1),
        takeUntilDestroyed()
      )
      .subscribe((outcome) => settle[outcome]());
  }

  ngOnInit(): void {
    this.titleService.setTitle(APP_BRANDING.browserTitle);
    this.sessionMonitor.start();
  }

  ngOnDestroy(): void {
    this.sessionMonitor.stop();
  }
}
